<template>
<div class="history">
    <p class="child-title">发展大事记</p>
    <p class="child-sub-title">DEVELOPMENT EVENTS</p>
    <div class="swiper-box">
        <swiper :options="options" v-if="list.length">
            <swiper-slide v-for="(item,index) in list" :key="index">
                <div class="top">
                    <span></span>
                    <hr />
                </div>
                <p class="name">{{item.name}}</p>
                <div class="box">
                    <div class="tag">{{item.name}}</div>
                    <div class="desc">{{item.content}}</div>
                </div>
            </swiper-slide>
            <div class="dot" slot="pagination"></div>
        </swiper>
    </div>
</div>
</template>

<script>
import {
    lc
} from "@/assets/js/api";
export default {
    data() {
        let that = this;
        return {
            options: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                on: {
                    slideChangeTransitionStart() {
                        that.active = this.realIndex;
                    },
                },
                pagination: {
                    el: ".dot",
                },
            },
            active: 0,
            list: [],
            group: 0,
        };
    },
    created() {
        lc().then((r) => {
            this.list = r.data.data;
            this.group = Math.ceil(r.data.data.length / 3);
        });
    },
};
</script>

<style lang="less" scoped>
.history {
    padding: 0.49rem 0.3rem;
    box-sizing: border-box;
    background: url("../../assets/img/history.png") no-repeat;
    background-size: cover;
    margin-top: 0.93rem;

    .child-title {
        color: white;
    }
}

.swiper-box {
    position: relative;

    //   .dot {
    //     text-align: center;

    //     span {
    //       width: 0.37rem;
    //       height: 0.1rem;
    //       background: #f6f6f6;
    //       border-radius: 0.05rem;
    //       display: inline-block;
    //       transition: all 0.15s linear;
    //     }

    //     span:not(:last-child) {
    //       margin-right: 7px;
    //     }

    //     span.active {
    //       background: #247bd7;
    //     }
    //   }

    .top {
        text-align: center;
        position: relative;
        text-align: center;
        width: 100%;
        height: 10px;

        span {
            display: inline-block;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: white;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 1;
        }

        hr {
            position: absolute;
            background: #247bd7;
            width: 100%;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            height: 1px;
            margin: 0;
            padding: 0;
            outline: none;
            border: none;
        }
    }

    .name {
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ffffff;
        opacity: 0.6;
        font-size: 0.24rem;
        text-align: center;
        margin: 0.2rem 0;
    }

    .box {
        width: 2rem;
        margin: 0 auto;

        .tag {
            line-height: 1.25rem;
            background: url("../../assets/img/tag.png") no-repeat;
            background-size: cover;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-bottom: 10px;
            font-size: 0.36rem;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #fffefe;
        }

        .desc {
            font-size: 0.2rem;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #000000;
            padding: 0.25rem 0.1rem;
            box-sizing: border-box;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 5;
            -webkit-box-orient: vertical;
            background: white;
            min-height: 1.79rem;
        }
    }
}

.dot {
    text-align: center;
}

/deep/.swiper-pagination-bullet {
    width: .37rem;
    height: .10rem;
    background: #f6f6f6;
    border-radius: .05rem;
    opacity: 1;
}

/deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    background: #247bd7;
}
</style>
